import { createTheme, DEFAULT_THEME, MantineTheme, MantineThemeOverride, mergeMantineTheme } from '@mantine/core';
import { useState } from 'react';

import { ActivityThemeStyles } from '../../common/themes/theme';
import { defaultActivityThemeStyles } from '../../themes/defaultActivityThemeStyles';
import { theme as mantineThemeOverride } from '../theme';

export type Theme = MantineTheme & { other: ActivityThemeStyles };

let themeOverrideInstance: MantineThemeOverride | null = null;
let themeInstance: Theme | null = null;

export const createNewThemeOverride = (defaultActivityThemeStyles: ActivityThemeStyles): MantineThemeOverride => {
  return createTheme({
    ...mantineThemeOverride,
    other: defaultActivityThemeStyles
  });
};

const getThemeOverrideInstance = (): MantineThemeOverride => {
  if (!themeOverrideInstance) {
    themeOverrideInstance = createNewThemeOverride(defaultActivityThemeStyles);
  }
  return themeOverrideInstance;
};

export const createNewTheme = (themeOverride: MantineThemeOverride): Theme => {
  return mergeMantineTheme(DEFAULT_THEME, themeOverride) as Theme;
};

const getThemeInstance = (): Theme => {
  if (!themeInstance) {
    const themeOverride = getThemeOverrideInstance();
    themeInstance = createNewTheme(themeOverride);
  }
  return themeInstance;
};

export const useThemeOverride = (): MantineThemeOverride => {
  const [themeOverride] = useState(getThemeOverrideInstance);
  return themeOverride;
};

export const useTheme = (): Theme => {
  const [theme] = useState(getThemeInstance);
  return theme;
};
